import React from 'react';
import Scatter from '@splunk/dashboard-visualizations/Scatter';

export default () => (
    <Scatter
        options={{
            'axisY.includeZero': true,
        }}
        encoding={{
            category: 'primary.status',
            x: 'primary.date_hour',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [
                        {
                            name: 'date_hour',
                        },
                        {
                            name: 'count',
                        },
                        {
                            name: 'status',
                        },
                    ],
                    columns: [
                        [
                            '13',
                            '14',
                            '15',
                            '16',
                            '17',
                            '18',
                            '19',
                            '10',
                            '20',
                            '21',
                            '22',
                            '23',
                            '3',
                            '4',
                            '5',
                        ],
                        [
                            '1109',
                            '1108',
                            '1098',
                            '1088',
                            '1097',
                            '1086',
                            '1107',
                            '1090',
                            '1150',
                            '2100',
                            '1070',
                            '1097',
                            '1096',
                            '1107',
                            '1152',
                        ],
                        [
                            '401',
                            '201',
                            '401',
                            '201',
                            '401',
                            '201',
                            '201',
                            '401',
                            '201',
                            '201',
                            '201',
                            '200',
                            '201',
                            '201',
                            '404',
                            '401',
                        ],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
